import React from 'react';
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {KensuTable} from "../../../../components/table/KensuTable";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {getPractitionerName} from "../../../../util/ProviderUtil";

import {useNavigateWithParams} from "../../../../util/NavUtils";
import {useTeamTabs} from "./TeamRouter";
import {useBusinessLogins} from "../../../../util/RpcHooks/BusinessLoginsLoader";
import {HelpTooltip} from "../../../../components/HelpTooltip/HelpTooltip";

const noLinkedAccountTooltip = 'There is no user account linked to this practitioner. ' +
    'Any booking notifications will go to the business admins';

/**
 * This deals with Practitioners - and specifically practitioners listed on
 * the business profile. Practitioners ARE versioned in case you want to change
 * a provider's name, description, etc, since these are shown on the public
 * booking website.
 * 
 * @constructor
 */
export const Practitioners = () => {

  const {businessProfile} = useProviderProfile();

  const navigate = useNavigateWithParams();

  // Linked user accoutnts are shown here too.. 
  const {rpcState, logins} = useBusinessLogins({forAdminHeader: false});

  const getLinkedUserAccount = (practitionerId: string | null | undefined) => {
    
    if (!practitionerId) {
      return ''
    }
    
    if (rpcState.state == 'pending') {
      return 'loading...'
    }
    
    const linkedLogin = logins?.find(login => login.linkedPractitionerId == practitionerId)
    
    if (linkedLogin) {
      return linkedLogin.lastLoginEmail
    }
    
    return <div className={'HorizontalFlex ColorRed'} style={{gap: 4}}>
      No account linked <HelpTooltip text={noLinkedAccountTooltip}/>
    </div>
  }
  
  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Team Members'}
                      tabs={useTeamTabs()}
                      buttons={[{
                        text: 'Add Practitioner', 
                        link: 'add'}]}
    />
    

    <div className={'ProviderToolAreaContent'}>
      Practitioners are the people on your team who offer classes or services.
      <br/><br/>
      
      If you'd like a Practitioner to have login access, please invite them to create 
      a Login and then link the Login to the Practitioner.
      <br/><br/>
      
      <KensuTable data={businessProfile?.practitioners} 
                  onRowSelected={r => navigate('edit/' + r.practitionerId)} columns={[
        {label: 'Display Name', 
          render: p => <>{getPractitionerName(p)}</>,
          showArchivedBadge: p => p.archived,
          sortString: p => p.firstName},
        {label: 'Bio', render: p => p.bio},
        {label: 'Linked User Account', render: p => getLinkedUserAccount(p.practitionerId)},
      ]}/>

      {!businessProfile?.practitioners?.length && <div>
        <br/><br/>
        You haven’t added any team members yet—click “Add” above to get started.
      </div>}

    </div>
  </div>

};

